
export const colors = {
    background: {
        contrast: "#fff",
        contrast60: "rgba(255, 255, 255, 0.6);",
        default: "#EDEFE4",
        first: "#D3E5D4",
        first50: "rgba(181, 223, 183, 0.5)",
        second: "#D3E5E3",
        contrast70: "rgba(255, 255, 255, 0.7);",
        error70: "rgba(255, 215, 215, 0.7);",
        black60: "rgba(0, 0, 0, 0.6)",
        black73: "rgba(0, 0, 0, 0.73)",
        verified70: "rgba(203, 240, 202, 0.7)"
    },
    accent: {
        default: "#78C25E",
        hover: "#60B243",
        pressed: "#509438"
    },
    link: {
        contrast: "#fff",
        default: "#71B659",
        hover: "#609F46",
        pressed: "#4F833A",
        visited: "#71B659"
    },
    button: {
        contrast: "#fff",
        default: "#78C25E",
        hover: "#60B243",
        pressed: "#509438",
        disable: "#C7C9C7"
    },
    text: {
        contrast: "#fff",
        default: "#464646",
        secondary: "#7A7A7A",
        tertiary: "#8F8F8F",
        quaternary: "#C7C9C7"
    },
    icon: {
        contrast: "#fff",
        default: "#464646",
        secondary: "#7A7A7A",
        tertiary: "#8F8F8F",
        quaternary: "#C7C9C7"
    },
    statusBar: {
        contrast: "#fff",
        default: "#78C25E",
    },
    info: {
        error: "#E7372D",
        success: "#78C25E",
        grey: "#C7C9C7",
        yellow: "#FFD600",
        orange: "#F6AE3B",
        blue: "#5DA3EC",
        purple: "#C469FA",
        mediumSeaGreen: "rgba(51, 166, 104, 1)"
    },
    message: {
        adminColor: "#DAEFDB",
        userColor: "#EAEAEA"
    },
    scrollBar: {
        background: "#F4F4F4",
        slider: "#DEDEDE"
    }
}

export type Colors = typeof colors;

